import type { Components, Theme } from "@mui/material/styles";

export const MuiAccordionSummary: Components<Theme>["MuiAccordionSummary"] = {
  defaultProps: {
    component: "div",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // alignItems: "center",
      // using important because Material-UI has too many overrides
      cursor: "auto !important",
      display: "flex",
      fontFamily: theme.typography.fontFamily,
      fontSize: "0.875rem",
      minHeight: theme.spacing(5),
      userSelect: "auto",

      "&.Mui-expanded": {
        minHeight: "unset",
      },
    }),

    content: {
      margin: 0,
      "&.Mui-expanded": {
        margin: 0,
      },
    },

    // MUI AccordionSummary disables the hover highlight
    // this re-introduces it, but has to include transform in the transition for the icon rotation
    expandIconWrapper: ({ theme }) => ({
      transition: theme.transitions.create(["background-color", "transform"], {
        duration: theme.transitions.duration.shortest,
      }),
    }),
  },
};
